export default __webpack_public_path__ + "static/media/Grande-Wasserman42.154fe824.jpg";